import { render } from "./OrderDetailView.vue?vue&type=template&id=4c808c70&ts=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=ts"
export * from "./OrderDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__